import Vue from 'vue'
import { GET_PHASES, ERROR_XHR } from '../mutation-types.js'

export const getPhases = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('phase')
    .then(
      (response) => {
        dispatch(GET_PHASES, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/phaseActions.js